import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface DiagnosticSnapshot extends Snapshot {
    errorCodes: number[] | null;

    firmwareVersion: string | null;
    hardwareVersion: string | null;
    softwareVersion: string | null;

    memoryFree: number | null;
    memoryTotal: number | null;

    supportedBindingAndModes: string | null;

    currentTime: number | null;
    timezone: string | null;
    utcOffset: string | null;
}

export const diagnosticSnapshotSchema = snapshotSchema.extend({
    errorCodes: z.array(z.number()).nullable(),

    firmwareVersion: z.string().nullable(),
    hardwareVersion: z.string().nullable(),
    softwareVersion: z.string().nullable(),

    memoryFree: z.number().nullable(),
    memoryTotal: z.number().nullable(),

    supportedBindingAndModes: z.string().nullable(),

    currentTime: z.number().nullable(),
    timezone: z.string().nullable(),
    utcOffset: z.string().nullable(),
});

export const mockDiagnosticSnapshot = ({
    errorCodes = [0],

    firmwareVersion = 'firmware version',
    hardwareVersion = 'hardware version',
    softwareVersion = 'software version',

    memoryFree = 0,
    memoryTotal = 100,

    supportedBindingAndModes = 'binding modes',

    currentTime = 1000,
    timezone = 'Perth/Western Australia',
    utcOffset = '+8:00',

    ...snapshot
}: Partial<DiagnosticSnapshot> = {}): DiagnosticSnapshot => ({
    ...mockSnapshot(snapshot),

    errorCodes,

    firmwareVersion,
    hardwareVersion,
    softwareVersion,

    memoryFree,
    memoryTotal,

    supportedBindingAndModes,

    currentTime,
    timezone,
    utcOffset,
});
